// extracted by mini-css-extract-plugin
module.exports = {"more-like-this-wrapper":"MoreLikeThis_more-like-this-wrapper__Wn2yt"};